import { BreadcrumbItem } from '@src/api/common/BreadcrumbTypes';
import { PageTitle } from '@src/api/common/PageTitleType';

const Breadcrumbs: Array<BreadcrumbItem> = [
  {
    title: 'Demo',
    isLink: false,
  },
  {
    title: 'Apply Access Token',
    isLink: false,
  },
];

const Title: PageTitle = {
  title: 'Access Token',
};

export { Breadcrumbs, Title };